var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":_vm.top,"bottom":_vm.bottom,"left":_vm.left,"right":_vm.right},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_vm._t("tooltipActivator",null,{"on":on})]}}],null,true)},[_c('span',[_vm._t("content",function(){return [_vm._v("example tooltip text")]})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }